import { useAuth } from '@/zustand/auth-store';
import { Navigate, Outlet } from 'react-router-dom';
import { getLoginPath } from '@/utils/helpers';

const ProtectedRoute = () => {
  const accessToken = useAuth.getState().accessToken;

  if (!accessToken) {
    const redirectPath = getLoginPath();
    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
